var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ul-icon-flag",class:[("ul-icon-flag--" + (_vm.country.toLowerCase()))],attrs:{"title":_vm.title},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }